var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuaranteeGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_120_6171)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6199 5.5386L8.01211 9.23091L5.60693 6.76937",
  stroke: "url(#paint0_linear_120_6171)",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0259 1.23077V9.30462C14.0255 9.85772 13.9038 10.4037 13.6696 10.9022C13.4354 11.4007 13.0948 11.8389 12.673 12.1846L8.01293 16L3.35291 12.1846C2.93103 11.8389 2.59043 11.4007 2.35626 10.9022C2.12209 10.4037 2.00034 9.85772 2 9.30462V1.23077L8.01293 0L14.0259 1.23077Z",
  stroke: "url(#paint1_linear_120_6171)",
  strokeMiterlimit: 10
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_120_6171",
  x1: 5.60693,
  y1: 7.2128,
  x2: 13.957,
  y2: 7.35584,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_120_6171",
  x1: 2,
  y1: 7.25484,
  x2: 18.704,
  y2: 7.38691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6A4DBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2994A"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_120_6171"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
export { SvgGuaranteeGradient as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyMF82MTcxKSI+CjxwYXRoIGQ9Ik0xMS42MTk5IDUuNTM4Nkw4LjAxMjExIDkuMjMwOTFMNS42MDY5MyA2Ljc2OTM3IiBzdHJva2U9InVybCgjcGFpbnQwX2xpbmVhcl8xMjBfNjE3MSkiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMTQuMDI1OSAxLjIzMDc3VjkuMzA0NjJDMTQuMDI1NSA5Ljg1NzcyIDEzLjkwMzggMTAuNDAzNyAxMy42Njk2IDEwLjkwMjJDMTMuNDM1NCAxMS40MDA3IDEzLjA5NDggMTEuODM4OSAxMi42NzMgMTIuMTg0Nkw4LjAxMjkzIDE2TDMuMzUyOTEgMTIuMTg0NkMyLjkzMTAzIDExLjgzODkgMi41OTA0MyAxMS40MDA3IDIuMzU2MjYgMTAuOTAyMkMyLjEyMjA5IDEwLjQwMzcgMi4wMDAzNCA5Ljg1NzcyIDIgOS4zMDQ2MlYxLjIzMDc3TDguMDEyOTMgMEwxNC4wMjU5IDEuMjMwNzdaIiBzdHJva2U9InVybCgjcGFpbnQxX2xpbmVhcl8xMjBfNjE3MSkiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTIwXzYxNzEiIHgxPSI1LjYwNjkzIiB5MT0iNy4yMTI4IiB4Mj0iMTMuOTU3IiB5Mj0iNy4zNTU4NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNkE0REJDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0YyOTk0QSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMTIwXzYxNzEiIHgxPSIyIiB5MT0iNy4yNTQ4NCIgeDI9IjE4LjcwNCIgeTI9IjcuMzg2OTEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzZBNERCQyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGMjk5NEEiLz4KPC9saW5lYXJHcmFkaWVudD4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMjBfNjE3MSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";